import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gitOpsWorkflowReconcile } from '@api/sdk.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { workflowQueryKeys } from '../../queries/query-keys';

async function reconcileWorkflow(id: number) {
  const { data } = await gitOpsWorkflowReconcile({ path: { id } });

  return data;
}

/**
 * Asks every environment running the workflow to reconcile without waiting for
 * its interval, which re-applies the manifests and puts back anything drifted.
 *
 * The environments act on their next poll rather than immediately, so the status
 * this invalidates will not have changed yet.
 */
export function useReconcileWorkflow() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reconcileWorkflow,
    ...withError('Unable to request a reconcile'),
    ...withInvalidate(queryClient, [workflowQueryKeys.all]),
  });
}
